module.exports = __webpack_public_path__ + "img/aaron-griffin-drift.3b82852.jpg";